// extracted by css-extract-rspack-plugin
export default {"wrapperAdd":"iVH9T4_hCfE3ZC6P","titleAdd":"JdxBI2uc7dQXGbLz","formAddDealer":"dz7AMWbOtjIwJlBp","addDealer":"fxLzHc1SZUaJOXNp","inputAdd":"QxhrJhcnrxwXYJiH"};